var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.to || _vm.href)?_c('a',{class:_vm.linkClasses,on:{"click":_vm.handleClick}},[_vm._t("default")],2):_c('span',{class:_vm.linkClasses},[_vm._t("default")],2),_vm._v(" "),(!_vm.showSeparator)?_c('span',{class:_vm.separatorClasses,domProps:{"innerHTML":_vm._s(_vm.separator)}}):_c('span',{class:_vm.separatorClasses},[_vm._t("separator")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/breadcrumb/breadcrumb-item.vue